(function() {
  'use strict';

  var integrationConfig = {
    template: require('./integration-config.html'),
    controller: 'IntegrationConfigCtrl',
  };

  angular
    .module('mandaeApp')
    .component('integrationConfig', integrationConfig)
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('integration-config', {
          parent: 'perfil',
          url: '/minhas-integracoes/:provider',
          component: 'integrationConfig',
          authenticate: true,
        });
    }]);

}());
